<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <!-- 申請日期 -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">申請日期</label>
                <ValidationProvider
                  :rules="{ dateRangeRequired: true }"
                  v-slot="{ errors }"
                >
                  <date-picker
                    class="w-100"
                    type="date"
                    range
                    placeholder="YYYY-MM-DD~YYYY-MM-DD"
                    v-model="applyDateRange"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">招募期限</label>
                <date-picker
                  class="w-100"
                  type="date"
                  range
                  placeholder="YYYY-MM-DD~YYYY-MM-DD"
                  v-model="dueDateRange"
                />
              </div>
            </div>
            <!-- 需求單單號 -->
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="ManpowerDemandNo">
                  {{ i18n("Basic.DemandNo") }}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="ManpowerDemandNo"
                  placeholder="請輸入關鍵字"
                  @keyup.enter="
                    getOpening({
                      page: tableInfo.page,
                      per_page: tableInfo.per_page,
                    })
                  "
                  v-model.trim="opening.ManpowerDemandNo"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">需求單名稱</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="請輸入關鍵字"
                  @keyup.enter="
                    getOpening({
                      page: tableInfo.page,
                      per_page: tableInfo.per_page,
                    })
                  "
                  v-model.trim="opening.manpowerDemandName"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-2">
              <div class="form-group">
                <label for="">{{ i18n("Position.PositionName") }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="PositionName"
                  placeholder="請輸入關鍵字"
                  @keyup.enter="
                    getOpening({
                      page: tableInfo.page,
                      per_page: tableInfo.per_page,
                    })
                  "
                  v-model.trim="opening.PositionName"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-2">
              <button
                type="button"
                class="btn btn-primary btn-search"
                style="margin-top: 30px; margin-left: 10px"
                @click="
                  handleSubmit(
                    getOpening({
                      page: tableInfo.page,
                      per_page: tableInfo.per_page,
                    })
                  )
                "
              >
                {{ i18n("Buttons.Search") }}
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        class="opening-table"
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="onChangeQuery"
      >
        <!-- QRcode -->
        <template slot="QRcode" slot-scope="props">
          <img
            style="
              border: 1px solid rgba(0, 0, 0, 0.2);
              border-radius: 5px;
              width: 40px;
              padding: 1px;
              cursor: pointer;
            "
            src="@/assets/img/Qrcode.png"
            alt="QRcode"
            data-toggle="modal"
            data-target="#qrcodeModal"
            @click="showQRCode(props.row)"
          />
        </template>

        <!-- 需求單資訊 -->
        <template slot="ManpowerData" slot-scope="props">
          <el-tooltip
            class="item"
            effect="light"
            :content="`招募期限：${$common.dateFormatter(props.row.RecruitmentDeadline)}`"
            placement="top"
          >
            <button
              type="button"
              class="btn btn-primary btn-sm btn-file"
              @click="viewDemand(props.row.ManpowerDemandNo)"
            >
              {{ props.row.ManpowerDemandNo }}<br />
              {{ props.row.ManpowerDemandName }}
            </button>
          </el-tooltip>
        </template>

        <!-- 申請日期 -->
        <template slot="ApplicantTime" slot-scope="props">
          <span>{{ $common.dateFormatter(props.cell_value) }}</span>
        </template>

        <!-- 履歷數量 -->
        <template slot="recruitStatus" slot-scope="props">
          <div class="recruit-status">
            <button
              type="button"
              class="status resume_list"
              @click="goResumeList(props.row)"
            >
              <div class="count">{{ props.row.ResumeCount }}</div>
            </button>
          </div>
        </template>
      </VueBootstrap4Table>
    </div>

    <!-- 檢視需求單 -->
    <DemandDetailModal />

    <!--顯示Qrcode-->
    <div id="qrcodeModal" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div
            style="
              display: block;
              text-align: center;
              color: #fff;
              padding: 20px;
            "
          >
            QRcode
          </div>
          <div class="modal-body">
            <template>
              <qrcode-vue
                :value="QRcode"
                :size="size"
                class="qrcode-wrap"
                level="H"
              />
            </template>
            <div style="margin-top: 5px">
              <input
                v-if="QRcode"
                id="copyText"
                type="text"
                size="5"
                style="opacity: 0"
                v-model="QRcode"
              />
              <br />
              <button
                ref="copyButton"
                style="background: inherit; border: none; margin-bottom: 25px"
                data-clipboard-target="#copyText"
                @click="initClipboard"
              >
                <span :class="{ copy_text: isCopy }" style="color: #fff">
                  {{ i18n("Basic.CopyLink") }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import QrcodeVue from "qrcode.vue";
// 複製
import Clipboard from "clipboard";

import DemandDetailModal from "@/components/back/Modal/DemandDetail";

import { config } from "@/components/back/table_config.js";

export default {
  name: "OpeningManage",

  components: {
    QrcodeVue,
    // Clipboard,
    DemandDetailModal,
  },
  data() {
    return {
      // 複製
      isCopy: false,
      clipboard: null,

      search: false,
      QRcode: "",
      size: 300,

      opening: {
        ManpowerDemandNo: null,
        PositionName: null,
        DemandDepartment: null,
        Applicant: null,
        RecruitmentStatus: null,
      },

      // 申請日期
      applyDateRange: [],
      // 招募期限
      dueDateRange: [],

      rows: [],
      totalData: 0,

      // table data
      tableInfo: {
        // 分頁資訊
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: "QRcode",
          name: "QRcode",
          slot_name: "QRcode",
        },
        {
          label: "需求單",
          name: "ManpowerData",
          slot_name: "ManpowerData",
        },
        {
          label: this.i18n("Position.PositionName"),
          name: "PositionName",
        },
        {
          label: this.i18n("DemandApply.DemandNumber"),
          name: "DemandNumber",
        },
        {
          label: this.i18n("Basic.ApplyDate"),
          name: "ApplicantTime",
          slot_name: "ApplicantTime",
        },
        {
          label: this.i18n("Basic.ApplyDepartment"),
          name: "DemandDepartment",
        },
        {
          label: this.i18n("Basic.ApplyUser"),
          name: "Applicant",
        },
        {
          label: this.i18n("StatusBar.ResumeList"),
          name: "recruitStatus",
          slot_name: "recruitStatus",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // QRcode 複製連結
    initClipboard() {
      //成功
      this.clipboard.on("success", () => {
        this.isCopy = true;
      });
      this.isCopy = false;
    },

    // 檢視需求單
    viewDemand(demandNo) {
      this.$store.commit("OpenDemandDetailModal", demandNo);
    },

    // table 分頁
    onChangeQuery(queryParams) {
      const vm = this;
      vm.tableInfo = queryParams;
      vm.getOpening({
        page: vm.tableInfo.page,
        per_page: vm.tableInfo.per_page,
      });
    },

    // 取得職缺管理 API
    getOpening({ page, per_page }) {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/paging/${vm.$cookies.get(
        "userId"
      )}`;

      const params = {
        ...vm.opening,
        ApplicationTimeStart:
          vm.applyDateRange[0] === null
            ? null
            : vm.$common.dateFormatter(vm.applyDateRange[0]),
        ApplicationTimeEnd:
          vm.applyDateRange[1] === null
            ? null
            : vm.$common.dateFormatter(vm.applyDateRange[1]),
        RecruitmentDeadlineStart:
          vm.dueDateRange.length < 1 || vm.dueDateRange[0] === null
            ? null
            : vm.$common.dateFormatter(vm.dueDateRange[0]),
        RecruitmentDeadlineEnd:
          vm.dueDateRange.length < 1 || vm.dueDateRange[1] === null
            ? null
            : vm.$common.dateFormatter(vm.dueDateRange[1]),
        isPaging: true,
        page: page,
        perPage: per_page,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.rows = response.data.Datas;
            vm.totalData = response.data.Quantity;
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 履歷數量 API
    goResumeList(item) {
      const ResumeCard = {
        DemandNo: item.ManpowerDemandNo,
        DemandGuid: item.Guid,
        DemandDepartment: item.DemandDepartment,
        ResumeType: item.ResumeType,
        PositionName: item.PositionName,
      };
      localStorage.setItem("ResumeCard", JSON.stringify(ResumeCard));
      this.$router.push({
        path: "/manager/progress/resume_list",
        query: { params: JSON.stringify(this.opening) },
      });
    },

    // 顯示 QRcode
    showQRCode() {
      this.isCopy = false;
      const url = window.location.origin;
      if (this.$cookies.get("candidateId")) {
        this.$common.checkConsentForm();
      } else {
        this.QRCode = `${url}/#/signIn`;
      }
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  mounted() {
    this.clipboard = new Clipboard(this.$refs.copyButton);
  },

  created() {
    this.applyDateRange = [
      new Date(this.$common.getThreeMonthsAgo()),
      new Date(this.$common.getToday()),
    ];
    if (this.$route.query.params) {
      this.opening = JSON.parse(this.$route.query.params);
    }
    this.getOpening({
      page: this.tableInfo.page,
      per_page: this.tableInfo.per_page,
    });
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .opening-table tr td {
  vertical-align: middle;
}

// 進度Circle
/deep/ .progress-style {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  .el-progress-circle {
    height: 53px !important;
    width: 53px !important;
  }
}

.copy_text {
  animation: 0.3s blink 1 steps(1);
}
@keyframes blink {
  50% {
    color: transparent;
  }
}
//狀態列
.recruit-status {
  .status {
    border-radius: 50%;
    border: none;
    width: 40px;
    height: 40px;
    background-size: 80%;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    background-color: #d7e6ff;
    margin-left: 7px;
    transition: all 0.2s;
    top: 0;

    &:hover {
      top: -5px;
      span {
        opacity: 1;
        background-color: #303c50;
        color: #fff;
        border-radius: 5px;
        padding: 2px 5px;
      }
    }

    span {
      font-size: 10px;
      position: absolute;
      bottom: -25px;
      transform: translateX(-50%);
      text-align: center;
      left: 50%;
      opacity: 0;
      z-index: 100;
      white-space: nowrap;
    }
    .count {
      position: absolute;
      right: -7px;
      bottom: -7px;
      background-color: red;
      width: 29px;
      height: 29px;
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      line-height: 29px;
      text-align: center;
      transform: scale(0.8);
    }

    &.resume_list {
      background-image: url("~@/assets/img/job_states/resume.png");
    }
    &.interviewing {
      background-image: url("~@/assets/img/job_states/interviewed.png");
    }
    &.interviewed {
      background-image: url("~@/assets/img/job_states/interviewing.png");
    }
    &.not_arrived {
      background-image: url("~@/assets/img/job_states/alternative.png");
    }

    &.interview_result {
      background-image: url("~@/assets/img/job_states/second-view.png");
    }

    &.appoint_result {
      background-image: url("~@/assets/img/job_states/hired.png");
    }

    &.days {
      background-image: url("~@/assets/img/job_states/days.png");
    }
  }
}

#qrcodeModal {
  .modal-content {
    background-color: rgba(0, 0, 0, 0.6);
    .modal-header,
    .modal-footer {
      border: none;
      color: #fff;
      display: block;
      text-align: center;
    }
    .modal-header:after {
      background-color: none;
    }
    .modal-body {
      text-align: center;
      .qrcode-wrap {
        display: inline-block;
        background-color: #fff;
        padding: 10px;
        border-radius: 5px;
      }
    }
  }
  img {
    width: 100%;
  }
}
</style>
